import {Component} from '@angular/core';

@Component({
  selector: 'jhi-accessibilite',
  templateUrl: './accessibilite.component.html',
  styleUrls: ['./accessibilite.component.scss']
})
export class AccessibiliteComponent {

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/accessibilite/accessibilite.component.ts